var React = require('react');

function PlayIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".play-icon-svg{fill:#666766;}")),React.createElement("path",{"className":"play-icon-svg","d":"M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,10,18Z","key":1}),React.createElement("path",{"id":"Polygon_2_copy_4","data-name":"Polygon 2 copy 4","className":"play-icon-svg","d":"M13.85,10l-6,4V6Z","key":2})]);
}

PlayIcon.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 20 20","width":"20","height":"20"};

module.exports = PlayIcon;

PlayIcon.default = PlayIcon;
